import { useContext, useEffect, useRef } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { titleHTML } from '../../helpers/title.helper';
import useRefreshTheme from '../../hooks/useRefreshTheme';
import { authActions } from '../../redux/actions';
import { persistor } from '../../redux/store';
import { socketIO } from '../../helpers/connectionSocket.helper';
import { ChatContext } from '../../contexts/chat/ChatProvider';

const Logout = () => {
    titleHTML('Cerraste sesión');

    const { user } = useContext(ChatContext);

    // REDUX
    const dispatch = useDispatch();
    const { authToken, _persist } = useSelector((state) => state.auth);
    const isRehydrated = _persist?.rehydrated;
    useRefreshTheme();
    const history = useHistory();
    const hasRequestedLogout = useRef(false);

    // PASSWORDLESS CODE
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get('code');

    // EFFECTS
    useEffect(() => {
        if (!isRehydrated) {
            return;
        }

        if (!hasRequestedLogout.current) {
            hasRequestedLogout.current = true;
            if (authToken && user?.id) {
                socketIO.emit('setUserStatus', {
                    user_id: user.id,
                    status: false,
                });
            }
            socketIO.disconnect();
            dispatch(authActions.logoutUser());
            persistor.pause();
            persistor.flush().finally(() => {
                persistor.purge().finally(() => {
                    persistor.persist();
                });
            });
            return;
        }

        if (!authToken) {
            const target = code ? `/auth?code=${code}` : '/auth';
            if (
                history.location.pathname + history.location.search !==
                target
            ) {
                history.replace(target);
            }
        }
    }, [authToken, code, dispatch, history, isRehydrated, user?.id]);

    return null;
};

export default Logout;
